import { Button, ButtonReversed } from "shared/components/Button";
import BatchTextInputSection from "./BatchTextInputSection";
import BatchFileInputSection from "./BatchFileInputSection";
import { video } from "shared/types/Report";
import LoadingWithProgressBar from "shared/components/Loading";
import Modal from "shared/components/Modal";
import useVideoBatchView from "features/homework/hooks/useVideoBatchView";
import { BatchBackdrop, BatchModal, BatchHeader, BatchTitle, BatchDesc, BatchBody, BatchSection, BatchFooter } from "../homeworkUi";

interface VideoBatchViewProps {
    list:video[],
    setList:React.Dispatch<React.SetStateAction<video[]>>,
    path: string,
    isOpen: boolean,
    onCancelClickHandler: () => void
}

const VideoBatchView = ({ isOpen, onCancelClickHandler, path, list, setList }: VideoBatchViewProps) => {
    const { videoList, setVideoList, onChangeInputHandler, onSaveClickHandler, showProgress, uploadFileName, progress, isSaveSucceed, onSuccessModalConfirmHandler, isOpenErrorModal, onErrorModalCloseClickHandler, errorMessage} = useVideoBatchView(list, setList, path, onCancelClickHandler);
    
    if (!isOpen) {
        return null;
    }

    return (
        <BatchBackdrop>
            <BatchModal>
                {showProgress ? <LoadingWithProgressBar title="파일 업로드" subTitle={uploadFileName} progress={progress}/> : null}
                <Modal isOpen={isSaveSucceed} onClose={onSuccessModalConfirmHandler} title="저장 성공" content="저장에 성공하였습니다"/>
                <Modal isOpen={isOpenErrorModal} onClose={onErrorModalCloseClickHandler} title="ERROR" content={errorMessage}/>
                <BatchHeader>
                    <BatchTitle>영상 일괄 등록</BatchTitle>
                    <BatchDesc>영상 파일과 제목·예시를 한 줄씩 맞춰 입력하세요. 제목 줄 수와 영상 개수가 같아야 저장됩니다.</BatchDesc>
                </BatchHeader>
                <BatchBody>
                    <BatchSection>
                        <BatchFileInputSection 
                            accept={"video"}
                            label="음원 포함 영상" 
                            fileList={videoList} 
                            setFileList={setVideoList}
                        />
                    </BatchSection>
                    <BatchSection $column>
                        <BatchTextInputSection 
                            label="제목" 
                            items={[{ label: "제목", name: "title" }]} 
                            onChangeHandler={onChangeInputHandler} 
                        />
                        <BatchTextInputSection 
                            label="예시" 
                            items={[{ label: "예시", name: "example" }]} 
                            onChangeHandler={onChangeInputHandler} 
                        />
                    </BatchSection>
                </BatchBody>
                <BatchFooter>
                    <ButtonReversed name="닫기" onButtonClick={onCancelClickHandler} />
                    <Button name="저장" onButtonClick={onSaveClickHandler} />
                </BatchFooter>
            </BatchModal>
        </BatchBackdrop>
    );
}

export default VideoBatchView;
